import { Controller } from "stimulus"

export default class extends Controller {
    static values = { seconds: Number };
    static targets = ["output", "modal", "modalCounter", "progressCircle"];
    static classes = ["counting", "stopped", "reset"]

    downloadTimer = null;
    timeleft = 0;
    stopped = false;
    lastTapTime = 0;
    
    connect() {
        console.log("[countdown] Controller connected");
        console.log("[countdown] Controller root element:", this.element);
        // Initialize - events will be attached when the modal is shown
    }

    disconnect() {
        // Clean up any active event listeners
        this._removeEventListeners();
    }
    
    _attachEventListeners() {
        // Only attach events if they haven't been attached yet
        if (!this._eventsAttached && this.hasModalTarget) {
            // Get both the background and timer elements
            const modalElements = this.modalTarget.querySelectorAll('div[data-action="dblclick->countdown#hideModal"]');
            const timerElement = this.modalTarget.querySelector('.pointer-events-auto');
            
            // Add touch event handlers
            modalElements.forEach(el => {
                el.addEventListener('touchstart', this.handleTap.bind(this));
            });
            
            if (timerElement) {
                timerElement.addEventListener('touchstart', this.handleTap.bind(this));
            }
            
            this._eventsAttached = true;
        }
    }
    
    _removeEventListeners() {
        if (this._eventsAttached && this.hasModalTarget) {
            const modalElements = this.modalTarget.querySelectorAll('div[data-action="dblclick->countdown#hideModal"]');
            const timerElement = this.modalTarget.querySelector('.pointer-events-auto');
            
            modalElements.forEach(el => {
                el.removeEventListener('touchstart', this.handleTap.bind(this));
            });
            
            if (timerElement) {
                timerElement.removeEventListener('touchstart', this.handleTap.bind(this));
            }
            
            this._eventsAttached = false;
        }
    }

    handleTap(event) {
        const currentTime = new Date().getTime();
        const tapLength = currentTime - this.lastTapTime;
        
        if (tapLength < 500 && tapLength > 0) {
            // Double tap detected
            this.hideModal();
            event.preventDefault();
        }
        
        this.lastTapTime = currentTime;
    }

    starttimer() {
        let that = this;
        const totalSeconds = this.secondsValue;
        const circumference = 2 * Math.PI * 45; // 45 is the radius of our circle
        
        // Initialize the timer value first
        if (that.hasModalCounterTarget) {
            that.modalCounterTarget.textContent = that.timeleft;
        }
        
        // Initialize the progress circle
        if (that.hasProgressCircleTarget) {
            that.progressCircleTarget.style.strokeDashoffset = 0;
        }
        
        // Show modal
        this.modalTarget.classList.remove('hidden');
        
        // Attach event listeners for touch/double-click events now that the modal is visible
        this._attachEventListeners();
        
        this.downloadTimer = setInterval(function () {
            if (that.timeleft <= 0) {
                clearInterval(that.downloadTimer);
                if (that.hasOutputTarget) {
                    that.outputTarget.innerHTML = "0";
                }
                that.element.classList.remove(that.stoppedClass);
                that.element.classList.add(that.resetClass);
                that.element.classList.remove(that.countingClass);
                
                // Hide modal when done
                that.hideModal();
            } else {
                if (that.hasOutputTarget) {
                    that.outputTarget.innerHTML = that.timeleft;
                }
                if (that.hasModalCounterTarget) {
                    that.modalCounterTarget.textContent = that.timeleft;
                }
                if (that.hasProgressCircleTarget) {
                    // Calculate progress and update circle
                    const progress = that.timeleft / totalSeconds;
                    const dashoffset = circumference * (1 - progress);
                    that.progressCircleTarget.style.strokeDashoffset = dashoffset;
                }
            }
            that.timeleft -= 1;
        }, 1000);
    }

    start(event) {
        console.log("[countdown] start() called");
        if (this.downloadTimer !== null) {
            console.log("[countdown] Timer exists");
            if (this.stopped === false) {
                console.log("[countdown] Pausing timer");
                this.stopped = true;
                clearInterval(this.downloadTimer);
                if (this.timeleft <= 0) {
                    console.log("[countdown] Timer reached zero, resetting");
                    this.timeleft = this.secondsValue;
                    this.element.classList.remove(this.stoppedClass);
                    this.element.classList.add(this.resetClass);
                    this.element.classList.remove(this.countingClass);
                } else {
                    console.log("[countdown] Timer paused with time left");
                    this.element.classList.add(this.stoppedClass);
                    this.element.classList.remove(this.resetClass);
                    this.element.classList.remove(this.countingClass);
                }
            } else {
                console.log("[countdown] Resuming timer");
                this.stopped = false;
                this.starttimer();
                this.element.classList.remove(this.stoppedClass);
                this.element.classList.remove(this.resetClass);
                this.element.classList.add(this.countingClass);
            }
        } else {
            console.log("[countdown] Starting fresh timer");
            this.timeleft = this.secondsValue;
            this.stopped = false;
            this.starttimer();
            this.element.classList.remove(this.stoppedClass);
            this.element.classList.remove(this.resetClass);
            this.element.classList.add(this.countingClass);
        }
    }

    hideModal() {
        this.modalTarget.classList.add('hidden');
        if (this.hasProgressCircleTarget) {
            this.progressCircleTarget.style.strokeDashoffset = 0;
        }
        
        // Clean up event listeners
        this._removeEventListeners();
    }
}
